import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../styles/pages/loading.css"; // Import the CSS file

const LoadingScreen = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 5000); // Simulating load time
    return () => clearTimeout(timer);
  }, [location]);

  return (
    loading && (
      <div className="loading-overlay">
        <img src="/images/loader.svg" alt="Loading Animation" className="loading-svg" />
      </div>
    )
  );
};

export default LoadingScreen;
